import React from "react"
import { graphql } from 'gatsby'

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/Hero"
import Projects from '../components/Projects';
import Ekibimiz from "../components/Ekibimiz"
import Galeri from "../components/Galeri"
import Faq from "../components/Faq"

const IndexPage = ({ data: { home, desktopImage, mobileImage } }) => (
  <Layout>
    <SEO
      title="Konya İnşaat - Anahtar Teslim | Ayazsan"
      description="Ayazsan İnşaat, Konya'da hizmet veren İnşaat firmasıdır. Villa, Ev, Konut, Bina, Anahtar Teslim inşaat hizmetleri ve projeler için ziyaret edin."
    />
    <Hero
      title="Konya'nın En İyi İnşaat Firması"
      subtitle="Anahtar Teslim İnşaat Hizmetleri"
      text="Müşterilerimizin istek ve ihtiyaçlarını saptayarak; Amacımız sizlere her türlü inşaat hizmetini profesyonelce ve en uygun fiyatlarla sunabilmek, aradığınız huzurlu ortamı anahtar teslim hazırlayabilmektir."
      desktop={desktopImage.childImageSharp.fluid}
      mobile={mobileImage.childImageSharp.fluid} />
      <Ekibimiz />
      <Projects title="Son Çalışmalarımız" projects={home.projects} />
    <Galeri logos={home.clientlogos}/>
    <Faq/>
  </Layout>
)

export const homeQuery = graphql`
{
  home: datoCmsProjeler { 
    clientlogos {
      fluid(maxWidth: 1200, imgixParams: { fm: "jpg", auto: "compress" }) {
        ...GatsbyDatoCmsFluid_noBase64
      }
    }
    projects {
      id
      projectlink
      projecttitle
      projecttags
      projectimage {
        fluid(maxWidth: 1200, imgixParams: { fm: "png", auto: "compress" }) {
          ...GatsbyDatoCmsFluid_noBase64
        }
      }
      projectdescriptionNode {
        childMarkdownRemark {
          html
        }
      }
      projectcolor
    }
  }
  desktopImage: file(relativePath: { eq: "bg.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1200) {
        ...GatsbyImageSharpFluid_noBase64
      }
    }
  }
  mobileImage: file(relativePath: { eq: "cm.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 500) {
        ...GatsbyImageSharpFluid_noBase64
      }
    }
  }
}
`

export default IndexPage
